import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

const SpeakersTopic = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

  // ✅ URL params se values lena
  const { speakerId, userId, conferenceId } = useParams();

  const token =
    sessionStorage.getItem("adminToken") ||
    sessionStorage.getItem("token") ||
    localStorage.getItem("adminToken") ||
    localStorage.getItem("token");

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.get(
          `https://eventscons.com/eventbackendnew/api/speakertopics?speaker_id=${speakerId}&user_id=${userId}&conference_id=${conferenceId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        console.log("API Response:", response.data);

        const apiData = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data.data)
          ? response.data.data
          : [];

        setTopics(apiData);
      } catch (error) {
        console.error("Error fetching topics:", error);
        toast.error("Failed to load topics");
        setTopics([]);
      } finally {
        setLoading(false);
      }
    };

    if (speakerId && userId && conferenceId) {
      fetchTopics();
    }
  }, [token, speakerId, userId, conferenceId]);

  // ✅ Status ke liye background colors
  const getStatusBg = (status) => {
    switch (status) {
      case "approved":
        return "#d4edda";
      case "rejected":
        return "#f8d7da";
      case "pending":
        return "#e2e3e5";
      default:
        return "#f9f9f9";
    }
  };

  // ✅ Update status API call
  const handleStatusChange = async (topicId, newStatus) => {
    setUpdatingId(topicId);
    try {
      const response = await axios.post(
        `https://eventscons.com/eventbackendnew/api/speakertopics/${topicId}/status`,
        { status: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Status updated:", response.data);
      toast.success("Status updated successfully");

      setTopics((prevTopics) =>
        prevTopics.map((t) =>
          t.id === topicId ? { ...t, status: newStatus } : t
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    } finally {
      setUpdatingId(null);
    }
  };

  return (
    <div className="form-container" style={{ width: "100%" }}>
      <h6 className="headingaddspeakers">Speaker Topics</h6>

      {loading ? (
        <p>Loading topics...</p>
      ) : topics.length > 0 ? (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {topics.map((topic) => (
            <li
              key={topic.id}
              style={{
                marginBottom: "12px",
                padding: "10px 15px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#f9f9f9",
              }}
            >
              <span style={{ fontWeight: "500" }}>{topic.topic_name}</span>

              {updatingId === topic.id ? (
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    border: "3px solid #ccc",
                    borderTop: "3px solid #333",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                />
              ) : (
                <select
                  style={{
                    padding: "6px 10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    backgroundColor: getStatusBg(topic.status),
                    fontWeight: "600",
                  }}
                  value={topic.status}
                  onChange={(e) => handleStatusChange(topic.id, e.target.value)}
                >
                  <option value="approved" style={{ background: "#d4edda" }}>
                    Approved
                  </option>
                  <option value="rejected" style={{ background: "#f8d7da" }}>
                    Rejected
                  </option>
                  <option value="pending" style={{ background: "#e2e3e5" }}>
                    Pending
                  </option>
                </select>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>No topics found.</p>
      )}

      {/* Spinner CSS */}
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default SpeakersTopic;